// @mui
import { Stack, Box } from '@mui/material';
import NavbarHorizontalV2 from './NavbarHorizontalV2';
// components
import RangeDatePicker from 'src/components/forms/RangeDatePicker';

// ----------------------------------------------------------------------

const ProgramTopNavWrapper: React.FC<{ navigation: any; showDatePicker?: boolean }> = ({
  navigation,
  showDatePicker,
}) => {
  return (
    <Stack
      spacing={2}
      direction={{ xs: 'column', md: 'row' }}
      justifyContent={'space-between'}
      alignItems={'center'}
      sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
    >
      {navigation ? <NavbarHorizontalV2 menuItems={navigation} /> : <Box />}

      {showDatePicker && (
        <Box sx={{ pb: { xs: 2, md: 1 } }}>
          <RangeDatePicker />
        </Box>
      )}
    </Stack>
  );
};

export default ProgramTopNavWrapper;
